export class TokenValidateRequestVM {
    twoFactorCode: string;
    userName: string;
    authenticationType: string = "phone";
    isOfficeChanged:boolean;
    isMFALogin:boolean
}
